import React, { useState } from 'react';
import { TextField, Button, Grid, Typography, Box, Container, CircularProgress } from '@mui/material';
import logoicn from "./../assets/images/iran.png";
import Bg from './../assets/images/backgroundLogin.png'
import { MuiOtpInput } from 'mui-one-time-password-input';
import axios from './../axios/api'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
const LoginPage = () => {
    const [contactNumber, setContactNumber] = useState('');
    const [activationCode, setActivationCode] = useState('');
    const [error, setError] = useState('');
    const [step, setStep] = useState(1);
    const [otp, setOtp] = React.useState('');
    const [errors, setErrors] = useState({ mobile: '' });
    const [LoadingButton, setLoadingButton] = useState(false);

    const navigate = useNavigate(); // Initialize the navigate function


    const handleChange = (newValue) => {
        setOtp(newValue)
    }
    const handleSend = async () => {
        try {
            setLoadingButton(true);

            const res = await axios.post('auth/send_code', {
                mobile: contactNumber,
            });
            toast.success(res.data?.message);
            setStep(2);
        } catch (error) {
            console.log(error);
            toast.error(error.response?.data?.message || 'An error occurred');
            if (error.response?.status === 422) {
                setErrors({
                    mobile: error.response?.data?.data ? error.response.data.data : '',
                });
            }
        }
        finally {
            setLoadingButton(false);

        }
    };

    const handleLogin = async () => {
        try {
            setLoadingButton(true);

            const res = await axios.post('auth/check_code', {
                mobile: contactNumber,
                code: otp
            });

            if (res.data?.data) {
                const { token, user } = res.data.data;

                // Ensure the data is valid JSON
                if (typeof token === 'string' && typeof user === 'object') {
                    if (user?.is_admin) {
                        localStorage.setItem('Token', JSON.stringify(token));
                        localStorage.setItem('CurrentUser', JSON.stringify(user));
                        toast.success(res.data?.message);
                        navigate('/dashboard');
                    } else {
                        toast.error("شما دسترسی به این بخش ندارید");

                    }

                    console.log('Data saved to localStorage');
                } else {
                    console.error('Invalid data format', res.data.data);
                }
            } else {
                console.error('No data received', res.data);
            }
        } catch (error) {
            console.error('Error during login', error);
            toast.error(error.response?.data?.message || 'An error occurred');

        }
        finally {
            setLoadingButton(false);

        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSend();
        }
    };

    const handleKeyDownSendOtp = (event) => {
        if (event.key === 'Enter') {
            handleLogin();
        }
    };

    const handleEditNumber = () => {
        setOtp('');
        setStep(1);
    };
    const handleMobileChange = (event) => {
        setContactNumber(event.target.value)
        if (errors.mobile) {
            setErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
        };
    }

    return (
        <div dir="rtl" style={{ display: 'flex', minHeight: '100vh', flexDirection: 'row-reverse' }}>
            <div style={{ flex: '1 1 67%', backgroundImage: `url(${Bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                {/* This div will cover the left two-thirds of the screen with an image */}
            </div>
            <div style={{
                flex: '1 1 33%', display: 'flex', alignItems: 'center',
                justifyContent: 'center', backgroundColor: '#292A2E'
            }}>
                <Container maxWidth="sm">
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mb: 4 }}>
                        <img
                            style={{ width: 93, height: 41, marginBottom: 16 }}
                            alt="Logo"
                            src={logoicn}
                        />

                    </Box>
                    <Box sx={{ backgroundColor: 'white', padding: 4, boxShadow: 3, borderRadius: 2, width: '100%' }}>
                        <Typography variant="h4" gutterBottom>
                            ورود به حساب کاربری
                        </Typography>
                        <TextField
                            fullWidth
                            label="شماره تماس"
                            variant="outlined"
                            onKeyDown={handleKeyDown}

                            value={contactNumber}
                            disabled={step === 2}
                            onChange={handleMobileChange}
                            margin="normal"
                            inputProps={{ maxLength: 11 }}
                            error={Boolean(errors.mobile)}
                            helperText={errors.mobile}
                        />
                        {step === 1 && (
                            <Button
                                onClick={() => handleSend()}
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                style={{ marginTop: '16px' }}
                                disabled={LoadingButton}

                            >



                                {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                <Typography color="white">ارسال کد فعالسازی</Typography>
                            </Button>
                        )}
                        {step === 2 && (
                            <>
                                <div dir="ltr">
                                    <MuiOtpInput value={otp} onChange={handleChange} onKeyDown={handleKeyDownSendOtp}
                                        TextFieldsProps={(index) => ({ size: 'medium', placeholder: '-' })}
                                    />

                                </div>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column', alignItems: 'flex-end',
                                    justifyContent: 'center',
                                }}>

                                    <Button
                                        onClick={handleEditNumber}
                                        variant="text"
                                    >

                                        <Typography variant='caption' color="primary" >ویرایش شماره تماس</Typography>
                                    </Button>
                                </Box>
                                <Button
                                    onClick={handleLogin}
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    style={{ marginTop: '16px' }}
                                    disabled={LoadingButton}
                                >
                                    {LoadingButton && <CircularProgress size={24} color="inherit" />}

                                    <Typography color="white">ورود به حساب کاربری</Typography>
                                </Button>
                            </>
                        )}
                        {error && (
                            <Typography variant="body2" color="error" gutterBottom>
                                {error}
                            </Typography>
                        )}
                    </Box>
                </Container>
            </div>
        </div>
    );
};

export default LoginPage;
